import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

export const generateWill = (payload) =>
  api.post("/wills/generate", payload).then((r) => r.data);

export const submitCallback = (payload) =>
  api.post("/callbacks", payload).then((r) => r.data);

// ---------- Payments ----------
export const getPricingConfig = () => api.get("/config/pricing").then((r) => r.data);

export const createPaymentOrder = (payload) =>
  api.post("/payments/create-order", payload).then((r) => r.data);

export const verifyPayment = (payload) =>
  api.post("/payments/verify", payload).then((r) => r.data);

export const getPaymentStatus = (willId) =>
  api.get(`/payments/status/${willId}`).then((r) => r.data);

// ---------- Drafts ----------
export const saveDraft = (id, state) =>
  api.post("/drafts/save", { id, state }).then((r) => r.data);
export const fetchDraft = (id) =>
  api.get(`/drafts/${id}`).then((r) => r.data);
export const emailResumeLink = (draftId, email, resumeUrl) =>
  api
    .post("/drafts/email-link", {
      draft_id: draftId,
      email,
      resume_url: resumeUrl,
    })
    .then((r) => r.data);
